export default {
  title: 'Exchange Rate Settings',

  // Search filter area
  search: {
    keyword: 'Keyword Search',
    keywordPlaceholder: 'Currency code, name',
    fromCurrency: 'Currency',
    fromCurrencyPlaceholder: 'Select currency',
    toCurrency: 'Base Currency',
    toCurrencyPlaceholder: 'Select base currency',
    status: 'Status',
    statusPlaceholder: 'Select status',
    all: 'All',
    enabled: 'Enabled',
    disabled: 'Disabled',
    searchButton: 'Search',
    resetButton: 'Reset'
  },

  // Action buttons
  actions: {
    addExchangeRate: 'Add Exchange Rate',
    batchEnable: 'Batch Enable',
    batchDisable: 'Batch Disable',
    edit: 'Edit',
    view: 'View',
    enable: 'Enable',
    disable: 'Disable',
    recordsCount: 'Total {count} records'
  },

  // Table columns
  table: {
    fromCurrency: 'Currency',
    toCurrency: 'Base Currency',
    exchangeRate: 'Exchange Rate',
    effectiveDate: 'Effective Period',
    to: 'to',
    status: 'Status',
    updateTime: 'Update Time',
    operation: 'Operation'
  },

  // Form
  form: {
    addTitle: 'Add Exchange Rate Setting',
    editTitle: 'Edit Exchange Rate Setting',
    fromCurrency: 'Currency',
    fromCurrencyPlaceholder: 'Please select currency',
    toCurrency: 'Base Currency',
    toCurrencyPlaceholder: 'Please select base currency',
    exchangeRate: 'Exchange Rate',
    exchangeRatePlaceholder: 'Please enter exchange rate',
    dateRange: 'Valid Period',
    dateRangePlaceholder: 'Please select valid period',
    startDatePlaceholder: 'Start Date',
    endDatePlaceholder: 'End Date'
  },

  // Detail modal
  detail: {
    title: 'Exchange Rate Setting Details',
    fromCurrency: 'Currency:',
    toCurrency: 'Base Currency:',
    exchangeRate: 'Exchange Rate:',
    effectiveDate: 'Effective Date:',
    expiryDate: 'Expiry Date:',
    status: 'Status:',
    updateTime: 'Update Time:',
    close: 'Close'
  },

  // Confirmation dialogs
  confirm: {
    toggleStatus: 'Confirm {action}',
    toggleStatusContent: 'Are you sure to set this exchange rate setting status to {action}?',
    batchEnable: 'Confirm Batch Enable',
    batchEnableContent: 'Are you sure to enable the selected {count} exchange rate settings?',
    batchDisable: 'Confirm Batch Disable',
    batchDisableContent: 'Are you sure to disable the selected {count} exchange rate settings?'
  },

  // Form validation
  validation: {
    fromCurrencyRequired: 'Please select currency',
    toCurrencyRequired: 'Please select base currency',
    exchangeRateRequired: 'Please enter exchange rate',
    dateRangeRequired: 'Please select valid period',
    exchangeRateFormat: 'Exchange rate must be a positive number',
    currencyDifferent: 'Currency and base currency must be different'
  },

  // Message prompts
  messages: {
    selectToEnable: 'Please select exchange rate settings to enable',
    selectToDisable: 'Please select exchange rate settings to disable',
    loadError: 'Data loading failed',
    currencyLoadError: 'Failed to load currency options',
    saveSuccess: 'Exchange rate setting saved successfully',
    saveError: 'Failed to save, please try again later',
    updateSuccess: 'Exchange rate setting updated successfully',
    updateError: 'Failed to update, please try again later',
    statusToggleSuccess: 'Exchange rate setting status updated to {status}',
    statusToggleError: 'Status toggle failed',
    batchEnableSuccess: 'Exchange rate setting status batch updated to enabled',
    batchEnableError: 'Batch enable failed',
    batchDisableSuccess: 'Exchange rate setting status batch updated to disabled',
    batchDisableError: 'Batch disable failed',
    dateOverlapError: 'Exchange rate setting already exists for this currency pair in this time period. Valid periods cannot overlap!'
  },

  // Status text
  statusText: {
    enabled: 'enabled',
    disabled: 'disabled'
  },

  // Currency options
  currencies: {
    CNY: 'CNY - Chinese Yuan',
    USD: 'USD - US Dollar',
    EUR: 'EUR - Euro',
    JPY: 'JPY - Japanese Yen',
    GBP: 'GBP - British Pound',
    HKD: 'HKD - Hong Kong Dollar',
    SGD: 'SGD - Singapore Dollar',
    AUD: 'AUD - Australian Dollar',
    CAD: 'CAD - Canadian Dollar'
  }
}